(function() {
    const headerEl = document.querySelector('.jsImageVideoHeader');

    if (headerEl) {
        headerEl.addEventListener('click', function(e) {
            if (e.target.classList.contains('jsAnchorTrigger') && e.target.dataset.triggerAnchor !== '') {
                e.preventDefault();
                goToTarget(e.target.dataset.triggerAnchor);
            }
        });
    }

    function goToTarget(targetId) {
        const el = document.querySelector(`[data-anchor="${targetId}"]`);

        if (el) {
            const bounds = el.getBoundingClientRect();
            window.scrollTo({top: window.scrollY + bounds.top - 80, behavior: 'smooth'});
        }
    }
})();